<template>
  <a-flex vertical class="module-list-item" :class="{active:checked}" v-bind="$attrs" v-on="$attrs">
    <a-flex justify="space-between" align="center" gap="small" class="module-list-item-header">
      <a-avatar :icon="h(IconFont,{type:'icon-module'})"/>
      <a-typography-text style="flex: 1 1 auto" :content="title"/>
      <a-typography-text v-if="must">必选</a-typography-text>
    </a-flex>
    <div>
      <a-typography-paragraph :ellipsis="{rows:2}" :content="description"/>
    </div>
    <a-flex justify="space-between" align="center">
      <a-typography-text type="secondary">{{ checked ? '已启用' : '未启用' }}</a-typography-text>
      <a-switch :disabled="must" :checked="checked" @change="onclick"/>
    </a-flex>
  </a-flex>
</template>

<script setup lang="ts">

import {h} from "vue";
import {IconFont} from "@/lib/util";

const props = defineProps<{ name: string, title: string, description: string, must: boolean, checked: boolean }>()
const emit = defineEmits(['on-checked'])

const onclick = () => {
  if (props.must) return
  emit('on-checked', props.name, !props.checked)
}
</script>

<style scoped lang="sass">
@import '~@/main.variable'
.module-list-item
  border-radius: 12px
  border: 1px solid #e5e7eb
  padding: 16px

  > .module-list-item-header
    margin-bottom: 12px

    > .ant-avatar
      background-color: rgb(245 247 250)
      color: rgb(78 89 105)

    > span:nth-child(2)
      font-size: 16px
      font-weight: 600

    > span:nth-child(3)
      color: white
      font-size: 12px
      padding: 4px 8px
      background-color: rgb(22 93 255)
      border-radius: 88px

  > div:nth-child(2)
    margin-bottom: 12px
    height: 42px
    overflow: hidden

  > div:nth-child(3) > span
    font-size: 12px

.active
  background-color: rgb(22 93 255 / 0.05)
  border: 2px solid $color-primary

  > .module-list-item-header
    > .ant-avatar
      background-color: rgb(22 93 255 / 0.1)
      color: $color-primary

</style>